module.exports = __webpack_public_path__ + "fonts/montserrat-bolditalic-webfont.e096a41.woff2";